import { connect } from 'react-redux';
import App from './pure';
import { fetchData, getByKey } from '../fetchActions';

const mapStateToProps = (state, ownProps) => ({
  homepage: getByKey('homepage', state)
})

const mapDispatchToProps = (dispatch) => ({
  loadData: () => dispatch(fetchData({
    url: `/api/page/coming-out`,
    key: 'homepage'
  }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App/connected.js